import { Box, Button, Flex, Image, Stack, Text, VStack } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import clientAxios from '../../config/axios'
import useAuth from '../../hooks/useAuth'

const quilmesImages = require.context('../../assets/images', true)

const VerifyEmail = () => {
  const { logout, setOobCode, oobCode } = useAuth()
  const navigate = useNavigate()
  const [userVerify, setUserVerify] = useState()

  const getUrl = () => {
    const url = window.location.href
    const mode = url.split('?')[1]

    if (mode === undefined) {
      navigate('/')

      return
    }
    const actionCode = mode.split('=')[1].split('&')[0]

    if (actionCode === 'verifyEmail') {
      const url = window.location.href
      // obtener el hash oobcode
      const params = new URLSearchParams(url)
      const oobCodeUrl = params.get('oobCode')

      // enviar el oobcode al backend
      return oobCodeUrl
    } else if (actionCode === 'resetPassword') {
      const url = window.location.href
      // obtener el hash oobcode
      const params = new URLSearchParams(url)
      const oobCodeUrl = params.get('oobCode')

      if (!oobCodeUrl) {
        navigate('/')

        return
      }

      setOobCode(oobCodeUrl)
      navigate('/password-recovery')
    }
  }

  useEffect(() => {
    getUrl()
  }, [])

  const handleVerify = async () => {
    const oobCode = getUrl()

    clientAxios.post('/auth/verifyEmail', { oobCode })
      .then(res => {
        setUserVerify(res.data)
        logout()
        navigate('/confirm-success')
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <Stack>
      <Flex bg={'black'} justifyContent={'center'}>
        <Image
          alt='logo'
          height='100%'
          padding={'2rem 0rem'}
          src={quilmesImages('./logo-email.svg')}
          width={{ base: '50%', md: '20%' }}
        />
      </Flex>
      <Box
        display={'grid'}
        padding={{ base: '1rem' }}
        paddingTop={{ base: '2rem', md: '6rem' }}
        placeContent={'center'}
        w={{ base: '100%', md: '75%' }}
      >
        <Text
          color={'#0A0808'}
          fontSize= {{ base: '26px', md: '30px' }}
        >
          Gracias por registrarte
        </Text>
        <Text
          color={'#0A0808'}
          fontSize={{ base: '14px', md: '16px' }}
        >
          Verificá tu dirección de correo electrónico para acceder a la plataforma.
        </Text>

        <Button
          marginTop={'2rem'}
          variant='btn-quilmes'
          w={{ base: '75%', md: '50%' }}
          onClick={handleVerify}
        >
          Verificar correo electrónico
        </Button>
        <Text
          color={'#0A0808'}
          fontSize={'14px'}
          paddingTop={'6rem'}
        >
          ¿No te registraste?
          <Link to='/'>
            <span className='create-count'> Cerrar cuenta</span>
          </Link>
        </Text>
      </Box>
    </Stack>
  )
}

export default VerifyEmail
